// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navbar-main-wrapper{
  background: #00A19B;
  border-bottom: 5px solid #1A1919;
  height: 100px;
  position: sticky;
  top: 0;
  z-index: 999;
}

.navbar-main-wrapper.dashbord-navbar-active{
  background: #FFFFFF;
  border-bottom: 5px solid #F3F3F3;
}

.navbar-main-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar-logo-wrap img {
  width: 93px;
}

.navbar-logo-wrap {
  display: flex;
  align-items: center;
  height: 100px;
  border-bottom: 5px solid #fff;
}


.navbar-logo-wrap-active{
  display: flex;
  align-items: center;
  height: 100px;
  border-bottom: 5px solid #1A1919;
}

.navbar-logo-wrap-active img {
  width: 92px;
  cursor: pointer;
}

.navbar-right-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
}

.navbar-right-wrap img{
  width: 35px;
  cursor: pointer;
}

.navbar-right-wrap img.nav-user-icon{
  width: 42px;
}

.nav-cart-wrapper {
  position: relative;
}

.nav-cart-item-count {
  position: absolute;
  cursor: pointer;
  top: -16px;
  left: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  min-height: 25px;
  background: #00A19B;
  border-radius: 50%;
}


.nav-cart-item-count p {
  font-size: 12px;
  color: #FFFFFF;
  margin: 0px;
  font-weight: 500;
}

img.profile-drop-icon {
  width: 11px;
  margin-left: 8px;
  cursor: pointer;
}


.profile-drop-wrapper {
  display: flex;
  align-items: center;
}


ul.dropdown-menu.show{
  width: 370px;
  height: 220px;
  background: #FFFFFF;
  border: 1px solid #707070;
  border-radius: 27px;
  padding: 20px 26px;
  overflow: auto;
  transform: translate(15px, 40px) !important;
}

.profile-nav-item-repeat {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 25px;
}

.profile-nav-item-repeat img{
  width: 35px;
}

.profile-nav-item-repeat p {
  font-size: 14px;
  color: #1A1919;
  font-weight: 500;
  margin: 0px;
}


button.logout-button {
  border: 1px solid #00A19BF7;
  border-radius: 9px;
  background-color: #F3F3F3;
  color: #00A19B;
  height: 49px;
}

.nav-cart-wrapper{
  cursor: pointer;
}

.nav-cart-wrapper:hover g#shopping-cart path,
.nav-cart-wrapper:hover circle#Ellipse_113, 
.nav-cart-wrapper:hover circle#Ellipse_114{
  fill: #00A19B;
}

.nav-notification-icon-wrap{
  cursor: pointer;
  position: relative;
}

.nav-notification-icon-wrap:hover svg path{
  fill: #00A19B;
}

.profile-drop-wrapper svg:hover path{
  fill: #00A19B;
}

.profile-drop-wrapper svg{
  cursor: pointer;
}


img.nav-profile-img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.notification-count-wrap {
  width: 10px;
  height: 10px;
  background: #FF0000;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  right: 6px;
}

.profiledrop-arrow-wrap{
  /* width: 10px; */
  padding: 2px 10px;
  cursor: pointer;
}


.profiledrop-arrow-wrap:hover img.profile-drop-icon {
  scale: 1.2;
}


.profiledrop-arrow-wrap:hover svg path{
  fill: #00A19B;
}

/******* Resposive css ****/
@media (max-width: 1024px) {
  .navbar-main-wrapper {
      border-bottom: 4px solid #1A1919;
      height: 72px;
  }

  .navbar-main-wrapper.dashbord-navbar-active {
      border-bottom: 4px solid #F3F3F3;
  }

  .navbar-logo-wrap img {
      width: 62px;
  }

  .navbar-logo-wrap-active img {
      width: 62px;
  }

  .navbar-logo-wrap-active {
      height: 72px;
      border-bottom: 4px solid #1A1919;
  }

  .navbar-logo-wrap {
      height: 72px;
      border-bottom: 4px solid #fff;
  }

  /* .navbar-right-wrap {
      display: none;
  } */


  .navbar-right-wrap {
      display: flex;
      align-items: center;
      gap: 6px;
  }

  .nav-location-wrap {
      display: flex;
      align-items: center;
      gap: 6px;
  }

  .navbar-right-wrap img {
      width: 35px;
  }
  
  img.nav-location-check-arrow{
      width: 6px;
  }

  img.nav-location-icon{
     margin-right: -8px;
  }
  
  .nav-location-wrap p{
      font-size: 14px;
      color: #00A19B;
      font-weight: 400;
      margin: 0px;
  }

  .nav-burger-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70px;
}

  .nav-burger-menu img {
    width: 30px;
    cursor: pointer;
  }
  
}


@media (max-width: 350px) {
  img.nav-location-check-arrow{
      display: none;
  }

  .nav-location-wrap p{
      display: none;
  }
}
/* 
@media (min-width: 768px) and (max-width: 1024px) {
  .navbar-main-wrapper {
      height: 86px;
      border-bottom: 4px solid #1A1919;
  }

  .navbar-logo-wrap img {
      width: 80px;
  }
  .navbar-logo-wrap-active img {
      width: 80px;
  }

  .navbar-logo-wrap {
      height: 86px;
      border-bottom: 4px solid #fff;
  }

  .navbar-logo-wrap-active {
      height: 86px;
      border-bottom: 4px solid #1A1919;
  }

} */

@media (min-width: 1025px) and (max-width: 1199px) {
  .navbar-main-wrapper {
      height: 70px;
      border-bottom: 4px solid #1A1919;
  }

  .navbar-logo-wrap img {
      width: 80px;
  }

  .navbar-logo-wrap-active img {
      width: 80px;
  }

  .navbar-logo-wrap {
      height: 70px;
      border-bottom: 4px solid #fff;
  }

  .navbar-logo-wrap-active {
      height: 70px;
      border-bottom: 4px solid #1A1919;
  }

  .profiledrop-arrow-wrap svg{
    width: 11px;
  }
}

@media (min-width: 1200px) and (max-width: 1599px) {
  .navbar-main-wrapper {
      height: 70px;
      border-bottom: 4px solid #1A1919;
  }

  .navbar-logo-wrap-active {
      height: 70px;
  }

  .navbar-logo-wrap img {
      width: 80px;
  }

  .navbar-logo-wrap {
      height: 70px;
      border-bottom: 4px solid #fff;
  }

  .navbar-logo-wrap-active img {
      width: 70px;
  }

  .navbar-right-wrap svg {
      width: 32px;
  }

  .nav-cart-item-count {
      top: -10px;
      left: 20px;
  }

  .profile-drop-wrapper svg{
      width: 42px;
  }

  .profiledrop-arrow-wrap svg{
    width: 11px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Components/Navbar/Navbar.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,UAAU;AACZ;;;AAGA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;MACI,gCAAgC;MAChC,YAAY;EAChB;;EAEA;MACI,gCAAgC;EACpC;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,YAAY;MACZ,gCAAgC;EACpC;;EAEA;MACI,YAAY;MACZ,6BAA6B;EACjC;;EAEA;;KAEG;;;EAGH;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,aAAa;MACb,mBAAmB;MACnB,QAAQ;EACZ;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,UAAU;EACd;;EAEA;KACG,kBAAkB;EACrB;;EAEA;MACI,eAAe;MACf,cAAc;MACd,gBAAgB;MAChB,WAAW;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;EAEE;IACE,WAAW;IACX,eAAe;EACjB;;AAEF;;;AAGA;EACE;MACI,aAAa;EACjB;;EAEA;MACI,aAAa;EACjB;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;;AAEH;EACE;MACI,YAAY;MACZ,gCAAgC;EACpC;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,YAAY;MACZ,6BAA6B;EACjC;;EAEA;MACI,YAAY;MACZ,gCAAgC;EACpC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;MACI,YAAY;MACZ,gCAAgC;EACpC;;EAEA;MACI,YAAY;EAChB;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,YAAY;MACZ,6BAA6B;EACjC;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,UAAU;MACV,UAAU;EACd;;EAEA;MACI,WAAW;EACf;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["\n.navbar-main-wrapper{\n  background: #00A19B;\n  border-bottom: 5px solid #1A1919;\n  height: 100px;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n}\n\n.navbar-main-wrapper.dashbord-navbar-active{\n  background: #FFFFFF;\n  border-bottom: 5px solid #F3F3F3;\n}\n\n.navbar-main-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-logo-wrap img {\n  width: 93px;\n}\n\n.navbar-logo-wrap {\n  display: flex;\n  align-items: center;\n  height: 100px;\n  border-bottom: 5px solid #fff;\n}\n\n\n.navbar-logo-wrap-active{\n  display: flex;\n  align-items: center;\n  height: 100px;\n  border-bottom: 5px solid #1A1919;\n}\n\n.navbar-logo-wrap-active img {\n  width: 92px;\n  cursor: pointer;\n}\n\n.navbar-right-wrap {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.navbar-right-wrap img{\n  width: 35px;\n  cursor: pointer;\n}\n\n.navbar-right-wrap img.nav-user-icon{\n  width: 42px;\n}\n\n.nav-cart-wrapper {\n  position: relative;\n}\n\n.nav-cart-item-count {\n  position: absolute;\n  cursor: pointer;\n  top: -16px;\n  left: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 25px;\n  min-height: 25px;\n  background: #00A19B;\n  border-radius: 50%;\n}\n\n\n.nav-cart-item-count p {\n  font-size: 12px;\n  color: #FFFFFF;\n  margin: 0px;\n  font-weight: 500;\n}\n\nimg.profile-drop-icon {\n  width: 11px;\n  margin-left: 8px;\n  cursor: pointer;\n}\n\n\n.profile-drop-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n\nul.dropdown-menu.show{\n  width: 370px;\n  height: 220px;\n  background: #FFFFFF;\n  border: 1px solid #707070;\n  border-radius: 27px;\n  padding: 20px 26px;\n  overflow: auto;\n  transform: translate(15px, 40px) !important;\n}\n\n.profile-nav-item-repeat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 25px;\n}\n\n.profile-nav-item-repeat img{\n  width: 35px;\n}\n\n.profile-nav-item-repeat p {\n  font-size: 14px;\n  color: #1A1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n\nbutton.logout-button {\n  border: 1px solid #00A19BF7;\n  border-radius: 9px;\n  background-color: #F3F3F3;\n  color: #00A19B;\n  height: 49px;\n}\n\n.nav-cart-wrapper{\n  cursor: pointer;\n}\n\n.nav-cart-wrapper:hover g#shopping-cart path,\n.nav-cart-wrapper:hover circle#Ellipse_113, \n.nav-cart-wrapper:hover circle#Ellipse_114{\n  fill: #00A19B;\n}\n\n.nav-notification-icon-wrap{\n  cursor: pointer;\n  position: relative;\n}\n\n.nav-notification-icon-wrap:hover svg path{\n  fill: #00A19B;\n}\n\n.profile-drop-wrapper svg:hover path{\n  fill: #00A19B;\n}\n\n.profile-drop-wrapper svg{\n  cursor: pointer;\n}\n\n\nimg.nav-profile-img {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.notification-count-wrap {\n  width: 10px;\n  height: 10px;\n  background: #FF0000;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  right: 6px;\n}\n\n.profiledrop-arrow-wrap{\n  /* width: 10px; */\n  padding: 2px 10px;\n  cursor: pointer;\n}\n\n\n.profiledrop-arrow-wrap:hover img.profile-drop-icon {\n  scale: 1.2;\n}\n\n\n.profiledrop-arrow-wrap:hover svg path{\n  fill: #00A19B;\n}\n\n/******* Resposive css ****/\n@media (max-width: 1024px) {\n  .navbar-main-wrapper {\n      border-bottom: 4px solid #1A1919;\n      height: 72px;\n  }\n\n  .navbar-main-wrapper.dashbord-navbar-active {\n      border-bottom: 4px solid #F3F3F3;\n  }\n\n  .navbar-logo-wrap img {\n      width: 62px;\n  }\n\n  .navbar-logo-wrap-active img {\n      width: 62px;\n  }\n\n  .navbar-logo-wrap-active {\n      height: 72px;\n      border-bottom: 4px solid #1A1919;\n  }\n\n  .navbar-logo-wrap {\n      height: 72px;\n      border-bottom: 4px solid #fff;\n  }\n\n  /* .navbar-right-wrap {\n      display: none;\n  } */\n\n\n  .navbar-right-wrap {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n  }\n\n  .nav-location-wrap {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n  }\n\n  .navbar-right-wrap img {\n      width: 35px;\n  }\n  \n  img.nav-location-check-arrow{\n      width: 6px;\n  }\n\n  img.nav-location-icon{\n     margin-right: -8px;\n  }\n  \n  .nav-location-wrap p{\n      font-size: 14px;\n      color: #00A19B;\n      font-weight: 400;\n      margin: 0px;\n  }\n\n  .nav-burger-menu {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 70px;\n}\n\n  .nav-burger-menu img {\n    width: 30px;\n    cursor: pointer;\n  }\n  \n}\n\n\n@media (max-width: 350px) {\n  img.nav-location-check-arrow{\n      display: none;\n  }\n\n  .nav-location-wrap p{\n      display: none;\n  }\n}\n/* \n@media (min-width: 768px) and (max-width: 1024px) {\n  .navbar-main-wrapper {\n      height: 86px;\n      border-bottom: 4px solid #1A1919;\n  }\n\n  .navbar-logo-wrap img {\n      width: 80px;\n  }\n  .navbar-logo-wrap-active img {\n      width: 80px;\n  }\n\n  .navbar-logo-wrap {\n      height: 86px;\n      border-bottom: 4px solid #fff;\n  }\n\n  .navbar-logo-wrap-active {\n      height: 86px;\n      border-bottom: 4px solid #1A1919;\n  }\n\n} */\n\n@media (min-width: 1025px) and (max-width: 1199px) {\n  .navbar-main-wrapper {\n      height: 70px;\n      border-bottom: 4px solid #1A1919;\n  }\n\n  .navbar-logo-wrap img {\n      width: 80px;\n  }\n\n  .navbar-logo-wrap-active img {\n      width: 80px;\n  }\n\n  .navbar-logo-wrap {\n      height: 70px;\n      border-bottom: 4px solid #fff;\n  }\n\n  .navbar-logo-wrap-active {\n      height: 70px;\n      border-bottom: 4px solid #1A1919;\n  }\n\n  .profiledrop-arrow-wrap svg{\n    width: 11px;\n  }\n}\n\n@media (min-width: 1200px) and (max-width: 1599px) {\n  .navbar-main-wrapper {\n      height: 70px;\n      border-bottom: 4px solid #1A1919;\n  }\n\n  .navbar-logo-wrap-active {\n      height: 70px;\n  }\n\n  .navbar-logo-wrap img {\n      width: 80px;\n  }\n\n  .navbar-logo-wrap {\n      height: 70px;\n      border-bottom: 4px solid #fff;\n  }\n\n  .navbar-logo-wrap-active img {\n      width: 70px;\n  }\n\n  .navbar-right-wrap svg {\n      width: 32px;\n  }\n\n  .nav-cart-item-count {\n      top: -10px;\n      left: 20px;\n  }\n\n  .profile-drop-wrapper svg{\n      width: 42px;\n  }\n\n  .profiledrop-arrow-wrap svg{\n    width: 11px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
